export default __webpack_public_path__ + "static/media/head02_ko_pc.1ee94fee.png";